import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY as string | undefined
const appVersion =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : undefined

const FallbackBoundary: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>{children}</>
)

let ErrorBoundary: React.ComponentType<React.PropsWithChildren> = FallbackBoundary

if (apiKey) {
  const bugsnag = Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: import.meta.env.MODE,
    appVersion,
  })

  const reactPlugin = bugsnag.getPlugin('react')
  if (reactPlugin) {
    ErrorBoundary = reactPlugin.createErrorBoundary(React)
  }
}

export { ErrorBoundary }
